import { render, staticRenderFns } from "./AgendaProveedorNuevoComponent.vue?vue&type=template&id=50d680b4&scoped=true&"
import script from "./AgendaProveedorNuevoComponent.vue?vue&type=script&lang=js&"
export * from "./AgendaProveedorNuevoComponent.vue?vue&type=script&lang=js&"
import style0 from "./AgendaProveedorNuevoComponent.vue?vue&type=style&index=0&id=50d680b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d680b4",
  null
  
)

export default component.exports